var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.billingAddress)?_c('div',[_c('CoCard',{attrs:{"variant":_vm.variant}},[_c('div',{staticClass:"d-flex justify-content-between align-items-center w-100"},[_c('div',[_c('CoHeadline',{attrs:{"level":3}},[_vm._v(" "+_vm._s(_vm.$t('labels.billingaddress'))+" ")])],1),_c('CoRoundButton',{attrs:{"variant":"icon","icon":"pencil"},on:{"click":_vm.openBillingAddressModal}})],1),_c('div',{staticClass:"d-flex flex-column align-items-start px-2"},[(_vm.userName)?_c('span',{staticClass:"d-block"},[_vm._v(_vm._s(_vm.userName))]):_vm._e(),(_vm.billingAddress.Company)?_c('span',{staticClass:"d-block"},[_vm._v(_vm._s(_vm.billingAddress.Company))]):_vm._e(),(_vm.billingAddress.AdditionalInfo)?_c('span',{staticClass:"d-block"},[_vm._v(" "+_vm._s(_vm.billingAddress.AdditionalInfo))]):_vm._e(),(_vm.billingAddress.Address)?_c('span',{staticClass:"d-block"},[_vm._v(_vm._s(_vm.billingAddress.Address))]):_vm._e(),(_vm.billingAddress.City)?_c('span',{staticClass:"d-inline"},[_vm._v(_vm._s(_vm.billingAddress.PostalCode)+" "+_vm._s(_vm.billingAddress.City))]):_vm._e(),(_vm.billingAddress.Country)?_c('span',{staticClass:"d-block"},[_vm._v(_vm._s(_vm.billingAddress.Country))]):_vm._e(),(_vm.billingAddress.VATNumber)?_c('span',{staticClass:"d-block"},[_vm._v(_vm._s(_vm.$t('labels.vatid'))+" "+_vm._s(_vm.billingAddress.VATNumber))]):_c('span',{staticClass:"d-block text-muted"},[_vm._v(_vm._s(_vm.$t('labels.vatidnotprovided')))]),(_vm.billingAddress.Phone)?_c('span',{staticClass:"d-block"},[_vm._v(_vm._s(_vm.billingAddress.Phone))]):_c('span',{staticClass:"d-block text-muted"},[_vm._v(_vm._s(_vm.$t('labels.phonenumbernotprovided')))])])]),_c('CoModal',{ref:"modal-edit-billing-address",attrs:{"title":_vm.$t('labels.billingaddressedit')},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('CoForm',{ref:"form-edit-billing-address",attrs:{"resetLabel":_vm.$t('labels.discard'),"submitLabel":_vm.$t('labels.save'),"submitMethod":_vm.saveBillingAddress,"inputs":[
                    {
                        Label: _vm.$t('labels.company'),
                        Type: 'text',
                        Name: 'Company',
                        Placeholder: _vm.$t('labels.company'),
                        Value: _vm.billingAddress.Company,
                        Autocomplete: 'billing organization',
                    },
                    {
                        Label: _vm.$t('labels.addressadditionalinformation'),
                        Type: 'text',
                        Name: 'AdditionalInfo',
                        Placeholder: _vm.$t('placeholders.addressadditionalinformation'),
                        Value: _vm.billingAddress.AdditionalInfo,
                        Autocomplete: 'billing address-line2',
                    },
                    {
                        Label: _vm.$t('labels.address'),
                        Type: 'text',
                        Name: 'Address',
                        Placeholder: _vm.$t('placeholders.address'),
                        Value: _vm.billingAddress.Address,
                        Required: true,
                        Autocomplete: 'billing address-line1',
                    },
                    {
                        Label: _vm.$t('labels.postalcode'),
                        Type: 'text',
                        Name: 'PostalCode',
                        Placeholder: _vm.$t('placeholders.postalcode'),
                        Value: _vm.billingAddress.PostalCode,
                        Required: true,
                        Autocomplete: 'billing postal-code',
                    },
                    {
                        Label: _vm.$t('labels.city'),
                        Type: 'text',
                        Name: 'City',
                        Placeholder: _vm.$t('labels.city'),
                        Value: _vm.billingAddress.City,
                        Required: true,
                        Autocomplete: 'billing locality',
                    },
                    {
                        Label: _vm.$t('labels.country'),
                        Type: 'text',
                        Name: 'Country',
                        Placeholder: _vm.$t('labels.country'),
                        Value: _vm.billingAddress.Country,
                        Required: true,
                        Autocomplete: 'billing country',
                    },
                    {
                        Label: _vm.$t('labels.vatid'),
                        Type: 'text',
                        Name: 'VatNumber',
                        Placeholder: _vm.$t('placeholders.vatid'),
                        Value: _vm.billingAddress.VATNumber,
                        Autocomplete: 'billing vat-id',
                    },
                    {
                        Label: _vm.$t('labels.phoneNumber'),
                        Type: 'text',
                        Name: 'Phone',
                        Placeholder: _vm.$t('labels.phoneNumber'),
                        Value: _vm.billingAddress.Phone,
                        Autocomplete: 'billing tel',
                    } ]},on:{"reset":_vm.cancelBillingAddress}})]},proxy:true}],null,false,277612678)})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }